import { safePage, safeSort, safeText } from '../../../../domain';
import { RestrictedKeys } from '../restricted.key';
import { Places } from '../../../route-consts';
import { SORT_FIELDS } from '../collaborators/collaborator-table';
/** Prefixo dos nomes deste arquivo na intencao - unico na aplicacao (ver `url-codes.test.ts`). */
const PREFIX = 'mo';
/** Os parametros deste place: vao para o endereco. */
const P = {
    MonitoringName: `${PREFIX}a`,
    MonitoringCpf: `${PREFIX}b`,
    PeriodStart: `${PREFIX}c`,
    PeriodEnd: `${PREFIX}d`,
    MonitoringSort: `${PREFIX}e`,
    MonitoringPage: `${PREFIX}f`
};
/** Os atributos deste place: viajam na intencao, mas nao vao para o endereco. */
const A = {
    /**
     * O presenter do CONCEITO, para a tela de dentro devolver o estado comum a ele.
     *
     * A listagem trabalha sobre uma copia (e dela que sai a assinatura da consulta),
     * mas quem PUBLICA o filtro no endereco e o conceito - dono unico do nome. Sem
     * esta ponte, ordenar a lista mudaria a tela e nao o endereco.
     */
    concept_owner: `${PREFIX}g`
};
/**
 * Os monitoramentos compartilhados com o profissional logado.
 *
 * Quatro filtros, que eram campos de um `react-hook-form`. Os nomes na URL sao
 * `de` e `ate` porque um endereco deve ler como uma frase - o nome tecnico do
 * campo (`periodStart`) fica onde ele importa, no servico.
 */
export class MonitoringKeys extends RestrictedKeys {
    get place() {
        return Places.monitoring;
    }
    get name() {
        return safeText(this._intent.getParameterAsString(P.MonitoringName));
    }
    set name(value) {
        this._intent.setParameter(P.MonitoringName, value ? value : undefined);
    }
    get cpf() {
        return safeText(this._intent.getParameterAsString(P.MonitoringCpf));
    }
    set cpf(value) {
        this._intent.setParameter(P.MonitoringCpf, value ? value : undefined);
    }
    /** Inicio do periodo, em `yyyy-MM-dd`. */
    get periodStart() {
        return this._intent.getParameterAsString(P.PeriodStart);
    }
    set periodStart(value) {
        this._intent.setParameter(P.PeriodStart, value ? value : undefined);
    }
    get periodEnd() {
        return this._intent.getParameterAsString(P.PeriodEnd);
    }
    set periodEnd(value) {
        this._intent.setParameter(P.PeriodEnd, value ? value : undefined);
    }
    // :: ordenacao e pagina
    get sort() {
        return safeSort(this._intent.getParameterAsString(P.MonitoringSort), SORT_FIELDS);
    }
    set sort(value) {
        this._intent.setParameter(P.MonitoringSort, value ? value : undefined);
    }
    get page() {
        return safePage(this._intent.getParameterAsNumber(P.MonitoringPage));
    }
    set page(value) {
        this._intent.setParameter(P.MonitoringPage, value > 1 ? value : undefined);
    }
    // :: o dono do estado comum
    /** O presenter do conceito - ver `A.concept_owner`. */
    get concept() {
        return this._intent.attributes.get(A.concept_owner);
    }
    set concept(value) {
        this._intent.attributes.set(A.concept_owner, value);
    }
}
//# sourceMappingURL=monitoring.key.js.map